<div class="modal-header">
    <h5 class="modal-title">{{ 'reporting_approve_resident_list' | translate }}</h5>
    <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="activeModal.dismiss('Cancel')"></button>
</div>
<form [formGroup]="formGroup">
    <div class="modal-body">
        @if (selectedAccount$ | async; as selectedAccount) {
            @if (selectedAccount.building.accounts.length > 1) {
                <p>
                    {{ 'reporting_approve_multiple_accounts_help_text' | translate }}
                    <br />
                    <b>{{
                        'reporting_ableto_enter_account_amounts_for_other_accounts' | translate
                    }}</b>
                </p>
            } @else {
                <p>
                    {{ 'reporting_approve_account_help_text' | translate }}
                </p>
            }
            <div class="row">
                <div class="col-6">
                    <app-checkbox-group
                        formControlName="sendEmail"
                        label="{{ 'reporting_SEND_RECEIPT_TO_MAIL' | translate }}" />
                </div>
                <div class="col-6">
                    <app-input-text-group
                        formControlName="email"
                        [maxLength]="emailMaxLength"></app-input-text-group>
                </div>
            </div>
            @if (saveLocations$ | async) {
                @for (account of selectedAccount.building.accounts; track account) {
                    <div class="d-flex justify-content-between align-items-center my-3">
                        <div>
                            <b>{{ account.accountHeading }}</b>
                            @if (account.costsAcceptedDate !== null) {
                                <br />
                                {{
                                    ('reporting_requested_and_approved_text' | translate).replace(
                                        '{0}',
                                        (account.costsAcceptedDate | appdate) ?? ''
                                    )
                                }}
                            }
                            @if (account.costState === 'OPEN') {
                                <br />
                                {{ 'reporting_requested_not_approved_text' | translate }}
                            }
                        </div>
                        <div>
                            @if (account.consumerAmountsAcceptedDate === null) {
                                <button
                                    type="button"
                                    class="btn btn-primary"
                                    (click)="approve(selectedAccount.building, account)">
                                    {{ 'reporting_Approve' | translate }}
                                </button>
                            } @else {
                                <b class="text-success">{{ 'reporting_approved' | translate }}</b>
                            }
                        </div>
                    </div>
                }
            } @else {
                <app-load />
            }
        } @else {
            <app-load />
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="activeModal.dismiss('Cancel')">
            {{ 'reporting_CLOSE' | translate }}
        </button>
    </div>
</form>
